// src/js/config/ui/orderSummaryDisplay.js

import { DOMElements } from '../dom.js';
import { formatter, updateDynamicBreakpoint } from '../../utils/helpers.js';

export function updateOrderSummaryDisplay(configData) {
    const {
        selectedConfigDisplay, displaySummaryPricesSection,
        displaySummaryPricesNotAvailable, displayCheapestTier,
        displayPackagePrice, displayAddonPrice, displayTotalPrice
    } = DOMElements;

    if (!selectedConfigDisplay || !displaySummaryPricesSection || !displaySummaryPricesNotAvailable) {
        return; // Avbryt om nödvändiga element saknas
    }

    // Dölj båda vyerna för att återställa
    displaySummaryPricesSection.classList.remove('is-visible');
    displaySummaryPricesNotAvailable.classList.remove('is-visible');

    const hasValidSummary = configData && typeof configData === 'object' && configData.summaryPricesForCheapestTier;
    const isKnownObject = configData && typeof configData === 'object';

    if (hasValidSummary) {
        // FALL 1: Allt är bra, visa priserna
        displaySummaryPricesSection.classList.add('is-visible');

        const summary = configData.summaryPricesForCheapestTier;
        if (displayCheapestTier) displayCheapestTier.textContent = configData.cheapestTier || 'N/A';
        if (displayPackagePrice) displayPackagePrice.textContent = formatter.format(summary.packagePrice || 0);
        if (displayAddonPrice) displayAddonPrice.textContent = formatter.format(summary.currentAddonPrice || 0);
        if (displayTotalPrice) displayTotalPrice.textContent = formatter.format(summary.totalPrice || 0);

    } else if (isKnownObject) {
        // FALL 2: Giltig config, men saknar prissummering (gammalt format). Visa meddelandet.
        displaySummaryPricesNotAvailable.classList.add('is-visible');
    }

    updateDynamicBreakpoint();
}